import { Compass } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';
import { useSeo } from '@/lib/seo';

export default function NotFound() {
  useSeo({ title: 'Page not found', noindex: true });
  return (
    <div className="container flex flex-col items-center py-24 text-center">
      <div className="mb-4 flex size-16 items-center justify-center rounded-full bg-brand-50 text-brand-700"><Compass className="size-8" /></div>
      <h1 className="font-display text-3xl font-semibold">We couldn’t find that page</h1>
      <p className="mt-2 max-w-md text-ink-muted">It may have moved, or it is not published yet. Try searching, or head back home.</p>
      <div className="mt-6 flex gap-3">
        <Link to="/"><Button tabIndex={-1}>Go home</Button></Link>
        <Link to="/search"><Button variant="outline" tabIndex={-1}>Search</Button></Link>
      </div>
    </div>
  );
}
